import script from "./ModeCompare.vue?vue&type=script&setup=true&lang=ts&name=ModeCompare"
export * from "./ModeCompare.vue?vue&type=script&setup=true&lang=ts&name=ModeCompare"

import "./ModeCompare.vue?vue&type=style&index=0&id=4777a403&scoped=true&lang=scss"
import "./ModeCompare.vue?vue&type=style&index=1&id=4777a403&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4777a403"]])

export default __exports__